import {ready} from './polyfill-service';
import store from './store';
import apiRequest from './api-request';
import {ServerTime} from './server-time';
import {AnalyticsQueue, AnalyticsQueueException} from './analytics-queue';
import {CacheManager, CacheTypeEnumerate} from '@aofl/cache-manager';
import * as objectUtils from '@aofl/object-utils';
import {resourceEnumerate} from '@aofl/resource-enumerate';
import {EnvironmentTypeEnumerate} from '@aofl/server-environment';
import {generate as uuid} from '@aofl/uuid';

module.exports = {
  store,
  CacheManager,
  CacheTypeEnumerate,
  objectUtils,
  resourceEnumerate,
  EnvironmentTypeEnumerate,
  uuid,
  ready,
  apiRequest,
  ServerTime,
  AnalyticsQueue,
  AnalyticsQueueException
};



// WEBPACK FOOTER //
// ./index.js